import { render, staticRenderFns } from "./BoxComponent.vue?vue&type=template&id=60c8471e&scoped=true"
import script from "./BoxComponent.vue?vue&type=script&lang=js"
export * from "./BoxComponent.vue?vue&type=script&lang=js"
import style0 from "./BoxComponent.vue?vue&type=style&index=0&id=60c8471e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c8471e",
  null
  
)

export default component.exports